module.exports = __webpack_public_path__ + "static/media/frame7.ee472c6c.png";